module.exports = __webpack_public_path__ + "media/customizations/sienna/back-0b941161ea4079df01233e9737acb3b6.jpg";